/**
 * NPC trait exports (ADR-070)
 */

export { NpcTrait, type INpcData } from './npcTrait';
